import { Box } from '@chakra-ui/react';

const StyledPercentContainer = ({ dataTestId = '', ...props }) => {
  return (
    <Box width='calc(50% - 1px)' flex={1} data-testid={dataTestId} {...props} />
  );
};

export default StyledPercentContainer;
